import { render, staticRenderFns } from "./TurnitinServiceApp.vue?vue&type=template&id=598df96a&scoped=true&"
import script from "./TurnitinServiceApp.vue?vue&type=script&lang=js&"
export * from "./TurnitinServiceApp.vue?vue&type=script&lang=js&"
import style0 from "./TurnitinServiceApp.vue?vue&type=style&index=0&id=598df96a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598df96a",
  null
  
)

export default component.exports